import { render, staticRenderFns } from "./CadastrarMedicoServico.vue?vue&type=template&id=2ddeb78a&scoped=true"
import script from "./CadastrarMedicoServico.vue?vue&type=script&lang=js"
export * from "./CadastrarMedicoServico.vue?vue&type=script&lang=js"
import style0 from "./CadastrarMedicoServico.vue?vue&type=style&index=0&id=2ddeb78a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ddeb78a",
  null
  
)

export default component.exports